import type { ReactElement, ReactNode } from "react";
import styles from "./AuthLayout.module.css";

export interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps): ReactElement {
  return <div className={styles.layout}>{children}</div>;
}
